document.addEventListener('click', function (event) {
  const opener = event.target.closest('[data-energy-dialog-open]');

  if (opener) {
    event.preventDefault();
    event.stopPropagation();

    const dialogId = opener.getAttribute('data-energy-dialog-open');
    const dialog = document.getElementById(dialogId);

    if (!dialog) return;


    /* Load image only when the popup is first requested */

    const deferredImages = dialog.querySelectorAll('[data-energy-label-image]');

    deferredImages.forEach(function (deferredImage) {
      if (
        !deferredImage.getAttribute('src')
        && deferredImage.dataset.src
      ) {
        deferredImage.setAttribute(
          'src',
          deferredImage.dataset.src
        );
      }
    });


    /* Load PDF only when the popup is first requested */

    const deferredPdfs = dialog.querySelectorAll('[data-energy-label-pdf]');

    deferredPdfs.forEach(function (deferredPdf) {
      if (
        !deferredPdf.getAttribute('src')
        && deferredPdf.dataset.src
      ) {
        deferredPdf.setAttribute(
          'src',
          deferredPdf.dataset.src
        );
      }
    });


    /* Return keyboard focus to the badge after closing */

    dialog.addEventListener(
      'close',
      function () {
        opener.focus();
      },
      { once: true }
    );


    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    return;
  }


  /* Close button */

  const closer = event.target.closest(
    '[data-energy-dialog-close]'
  );

  if (closer) {
    event.preventDefault();

    const dialog = closer.closest('dialog');

    if (!dialog) return;

    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }
});


/* Clicking the backdrop closes the popup */

document.addEventListener('click', function (event) {
  if (
    event.target.matches('dialog.energy-label-dialog') &&
    event.target.open
  ) {
    event.target.close();
  }
});